import React from 'react';
import { Snackbar, Alert } from '@mui/material';

/**
 * A reusable error snackbar component that can be used across the application
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether the snackbar is open
 * @param {string} props.message - The error message to display
 * @param {Function} props.onClose - Function to call when the snackbar is closed
 * @param {string} [props.severity="warning"] - The severity of the alert (error, warning, info, success)
 * @param {number} [props.duration=5000] - Auto-hide duration in milliseconds
 * @param {Object} [props.anchorOrigin={ vertical: 'top', horizontal: 'center' }] - Position of the snackbar
 */
const ErrorSnackbar = ({ 
  open, 
  message, 
  onClose, 
  severity = "warning", 
  duration = 3000,
  anchorOrigin = { vertical: 'top', horizontal: 'center' }
}) => {
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    onClose();
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default ErrorSnackbar;